export const removeEmptyKey = (object: Record<string, unknown>): Record<string, unknown> => {
  const clone = { ...object };

  Object.entries(clone).forEach(([key, val]) => {
    if (!val) delete clone[key];
  });

  return clone;
};
